import { createContext, useContext } from 'react';
/**
 * `true` below a kit `Table`. Read by `StatusTag`: a status chip with a hint
 * is a tab stop on a page, but in a table cell it is not — fifty rows would be
 * fifty stops, and the row's drawer carries the same status. The hint stays
 * the chip's `aria-description` either way.
 */
export const InTableContext = createContext(false);
export function useInTable() {
    return useContext(InTableContext);
}
//# sourceMappingURL=in-table-context.js.map